export const FETCH_DAILY_PINGS = "FETCH_DAILY_PINGS";
export const FETCH_DAILY_PINGS_SUCCESS = "FETCH_DAILY_PINGS_SUCCESS";
export const FETCH_DAILY_PINGS_FAILED = "FETCH_DAILY_PINGS_FAILED";

export const SET_FIELD_ERROR_MESSAGE = "SET_FIELD_ERROR_MESSAGE";
